import { FooterMk2 } from 'components/organisms/layout/footer-mk2/footer-mk2';

const FooterPage = () => {
  return <FooterMk2 />;
};

export default FooterPage;
